import './App.css';
import Nav from './components/Nav';
import {Routes, Route} from "react-router-dom";
import Home from './pages/Home/Home';
import Product from './pages/Home/Product/Product';
import Download from './pages/Download/Download';
import Application from './pages/Applications/Application';
import Contact from './pages/Contact/Contact';
function App() {
  return (
    <div className="App">
       <Nav/>
       <Routes>
        <Route path='/contact' element={<Contact/>}/>
        <Route path='product/:name' element={<Product/>}/>
        <Route path='/download' element={<Download/>}/>
        <Route path='/application' element={<Application/>}/>
        <Route path='/' element={<Home/>}/>
       </Routes>
    </div>
  );
}

export default App;
